const wrongPasswordLockoutSeconds = 60 * 60;

export const appConstant = {
  maxWrongPasswordCount: 20,
  wrongPasswordLockoutSeconds,
  wrongPasswordLockoutHours: wrongPasswordLockoutSeconds / 60 / 60,
} as const;
